import { render, staticRenderFns } from "./ModalLogout.vue?vue&type=template&id=aa52b33a&"
import script from "./ModalLogout.vue?vue&type=script&lang=js&"
export * from "./ModalLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports